export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  VERIFICATION_CODE_REQUEST: "VERIFICATION_CODE_REQUEST",
  VERIFICATION_CODE_SUCCESS: "VERIFICATION_CODE_SUCCESS",
  VERIFICATION_CODE_FAILURE: "VERIFICATION_CODE_FAILURE",

  USER_INFO_REQUEST: "USER_INFO_REQUEST",
  USER_INFO_SUCCESS: "USER_INFO_SUCCESS",
  USER_INFO_FAILURE: "USER_INFO_FAILURE",

  EDIT_USER_INFO_REQUEST: "EDIT_USER_INFO_REQUEST",
  EDIT_USER_INFO_SUCCESS: "EDIT_USER_INFO_SUCCESS",
  EDIT_USER_INFO_FAILURE: "EDIT_USER_INFO_FAILURE",

  APP_INFO_REQUEST: "APP_INFO_REQUEST",
  APP_INFO_SUCCESS: "APP_INFO_SUCCESS",
  APP_INFO_FAILURE: "APP_INFO_FAILURE",

  PASSWORD_RESET_REQUEST: "PASSWORD_RESET_REQUEST",
  PASSWORD_RESET_SUCCESS: "PASSWORD_RESET_SUCCESS",
  PASSWORD_RESET_FAILURE: "PASSWORD_RESET_FAILURE",

  UPLOAD_COMPANY_LOGO_EMPLOYER_REQUEST: "UPLOAD_COMPANY_LOGO_EMPLOYER_REQUEST",
  UPLOAD_COMPANY_LOGO_EMPLOYER_SUCCESS: "UPLOAD_COMPANY_LOGO_EMPLOYER_SUCCESS",
  UPLOAD_COMPANY_LOGO_EMPLOYER_FAILURE: "UPLOAD_COMPANY_LOGO_EMPLOYER_FAILURE",

  DELETE_COMPANY_LOGO_EMPLOYER_REQUEST: "DELETE_COMPANY_LOGO_EMPLOYER_REQUEST",
  DELETE_COMPANY_LOGO_EMPLOYER_SUCCESS: "DELETE_COMPANY_LOGO_EMPLOYER_SUCCESS",
  DELETE_COMPANY_LOGO_EMPLOYER_FAILURE: "DELETE_COMPANY_LOGO_EMPLOYER_FAILURE",
};
